export default __webpack_public_path__ + "static/media/team_othman.97856052.jpg";